import {Injectable} from '@angular/core';
import {DataService} from './data.service';
import {CallScenario, SupportedLanguagesEnum, VoiceBotType} from '../models/voice-bot.model';
import {map, Observable, ReplaySubject} from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class VoiceBotService {
    private _voiceBotTypes$ = new ReplaySubject<VoiceBotType[]>(1);
    private _voiceBotTypesSaved$ = new ReplaySubject<boolean>(1);
    private ONE_MINUTE_TIMEOUT = 6000;
    private mockedVoices: VoiceBotType[] = [
        {
            name: 'Maria',
            description: 'Maria redet',
            labels: {
                language: 'DE',
                accent: 'german',
                description: 'bla',
                age: '12',
                use_case: 'string',
                gender: 'female',
            },
            voice_id: 'string',
            preview_url: 'string',
            fine_tuning: {
                language: 'string',
                state: {
                    eleven_multilingual_v2: 'string'
                }
            }
        },
        {
            name: 'Kai',
            description: 'redet gerne',
            labels: {
                language: 'DE',
                accent: 'german',
                description: 'bla',
                age: '12',
                use_case: 'string',
                gender: 'male',
            },
            voice_id: 'string',
            preview_url: 'string',
            fine_tuning: {
                language: 'string',
                state: {
                    eleven_multilingual_v2: 'string'
                }
            }
        }
    ];
    private testCallTriggered = false;
    public voiceBotTypes$ = this._voiceBotTypes$.asObservable();
    public voiceBotTypesSaved$ = this._voiceBotTypesSaved$.asObservable();
    private _testCallRunning$ = new ReplaySubject<boolean>(1);
    private _testCallTriggered$ = new ReplaySubject<boolean>(1);
    public testCallRunning$ = this._testCallRunning$.asObservable();
    public testCallTriggered$ = this._testCallTriggered$.asObservable();

    constructor(private dataService: DataService) {
        this.testCallTriggered$.subscribe((val) => {
            this.testCallTriggered = val;
        });
        
    }

    public fetchVoiceBotTypes(shortLanguage: SupportedLanguagesEnum): void {
        this.dataService.fetchVoiceBoxVoices(shortLanguage).pipe(
            map((voiceBotTypes: VoiceBotType[]) => {
                return voiceBotTypes.map((voiceBotType: VoiceBotType) => {
                    if (!voiceBotType?.labels?.language) {
                        voiceBotType.labels.language = SupportedLanguagesEnum.EN;
                    }
                    return voiceBotType;
                })
            })
        ).subscribe(
            (voiceBotTypes: VoiceBotType[]) => {
                this._voiceBotTypes$.next(voiceBotTypes);
            }
        );
    }

    public saveType(voiceBotId: string, phoneserviceId: string) {
        this.dataService.saveVoiceBotType(voiceBotId, phoneserviceId).subscribe(
            (res) => {
               console.log('voice bot type saved', res);
                this._voiceBotTypesSaved$.next(true);
            }
        );
    }

    public callScenariosAreEqual(callScenarioA: CallScenario, callScenarioB: CallScenario) {
        return JSON.stringify(callScenarioA) === JSON.stringify(callScenarioB);
    }

    public initTestCall(phoneNumber: string, phoneserviceId: string) {
        this.dataService.initTestCall(phoneNumber, phoneserviceId).subscribe(() => {
            console.log('init test call was successfully');
            this.initTestCallFeedback();
        })
    }

    public createCallScenario$(phoneServiceId: string, text: string): Observable<CallScenario> {
        return this.dataService.createCallScenario(phoneServiceId, text);
    }

    public deleteCallScenarioProperty$(psId: string, callScenario: CallScenario, propertyName: string) {
        return this.dataService.deleteCallScenarioProperty(psId, propertyName, callScenario);
    }

    deleteScenario$(psId: string, callScenario: CallScenario) {
        return this.dataService.deleteCallScenario(psId, callScenario.tool_id);
    }

    addProperty$(psId: string, callScenario: CallScenario, text: string) {
        return this.dataService.addCallScenarioProperty(psId, callScenario, text);
    }
    
    private initTestCallFeedback() {
        if (!this.testCallTriggered) {
            this._testCallTriggered$.next(true);
        }
        setTimeout(() => {
            console.log('fire....');
            this._testCallRunning$.next(true);
        }, this.ONE_MINUTE_TIMEOUT);
    }
}
